import { SIGNUP, VALIDATE_OTP, GENERATE_OTP, DOMAIN, CREATEJOB, UPLOAD_RESUME, SEARCH_JOB, LIST_JOB, EDIT_JOB, DELETE_JOB, GET_USER_SKILLS, APPLY_JOB, VIEW_APPLICATIONS, DOWNLOAD_RESUME } from "./apiEndpoints";

async function makeApiRequest(endpoint, method, requestBody) {
  try {
    const url = DOMAIN + endpoint;
    const config = {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (method === "POST" || method==="DELETE") {
      config.body = JSON.stringify(requestBody);
    }
    const response = await fetch(url, config);

    if (!response.ok) {
      throw new Error(`HTTP error!`);
    }

    try {
      const data = await response.json();
      return data;
    } catch (jsonError) {
      throw new Error("Failed to parse JSON response.");
    }
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}


export async function ResumeDownload(userId) {
  try {
    const url = DOMAIN + DOWNLOAD_RESUME;
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ user_id: userId }),
    };

    const response = await fetch(url, config);

    if (!response.ok) {
      const errorMessage = `HTTP error! Status: ${response.status} - ${response.statusText}`;
      console.error(errorMessage);
      throw new Error(errorMessage);
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = "resume.pdf"; // Adjust the filename and extension as needed
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Error:", error.message);
    throw error;
  }
}



export async function generateOTP(user_id) {
  return await makeApiRequest(GENERATE_OTP, "POST", { user_id });
}

export async function validateOTP(otp, user_id) {
  return await makeApiRequest(VALIDATE_OTP, "POST", { otp, user_id });
}

export async function signUp(userData) {
  return await makeApiRequest(SIGNUP, "POST", userData);
}

export async function createJob(jobState) {
  return await makeApiRequest(CREATEJOB, "POST", jobState);
}

export async function search_jobs(searchQuery) {
  return await makeApiRequest(SEARCH_JOB, "POST", searchQuery);
}

export async function list_jobs(userData) {
  return await makeApiRequest(LIST_JOB, "POST" , userData);
}


export async function get_skills(userId) {
  return await makeApiRequest(GET_USER_SKILLS, "POST", userId);
}

export async function del_jobs(jobId,userId) {
  return await makeApiRequest(DELETE_JOB + "/" + jobId, "DELETE",userId);
}

export async function apply_job(applyDetails) {
  return await makeApiRequest(APPLY_JOB, "POST", applyDetails);
}

export async function view_applications(job_id){
  return await makeApiRequest(VIEW_APPLICATIONS, "POST", job_id)
}

export const edit_job = async (formData) => {
  try {
    const response = await fetch(DOMAIN + EDIT_JOB, {
      method: "POST",
      //should not include any headers !IMP
      body: formData,
    });

    if (!response.ok) {
      const errorMessage = await response.json();
      throw new Error(errorMessage.error || "Failed to upload resume");
    }

    const editedJob = await response.json();
    console.log(editedJob);
    return editedJob;
  } catch (error) {
    console.error("Error uploading resume:", error.message);
    // Handle error
  }
};

export const uploadResume = async (formData) => {
  try {
    const response = await fetch(DOMAIN + UPLOAD_RESUME, {
      method: "POST",
      //should not include any headers !IMP
      body: formData,
    });

    if (!response.ok) {
      const errorMessage = await response.json();
      throw new Error(errorMessage.error || "Failed to upload resume");
    }

    const resumeData = await response.json();
    // Handle the resume data returned from the server
    console.log(resumeData);
    return resumeData;
  } catch (error) {
    console.error("Error uploading resume:", error.message);
    // Handle error
  }
};

export async function upload_img_to_database(formData) {
  await fetch(DOMAIN + CREATEJOB, {
    method: "POST",
    body: formData,
  })
    .then((res) => {
      console.log("Response: ", res);
      if (res.ok) {
        res.json().then((data) => console.log(data));
      } else {
        console.log(res);
        alert("Error processing image.");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      alert("An error ocurred while processing the image");
    });
}
